import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsDispatchPluginModule } from "@ngxs-labs/dispatch-decorator";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsStoragePluginModule } from "@ngxs/storage-plugin";
import { NgxsModule } from "@ngxs/store";
import { NgxsResetPluginModule } from "ngxs-reset-plugin";

import { AppStateList, VolvoState } from "~/core/store";
import { AdminSharedModule } from "./admin-shared/admin-shared.module";

@NgModule({
    imports: [
        CommonModule,
        NgxsModule.forRoot([...VolvoState]),
        NgxsStoragePluginModule.forRoot({
            key: [
                AppStateList.language,
                AppStateList.search,
                AppStateList.buckets,
                AppStateList.countrySettings,
                AppStateList.regionalSettings,
                AppStateList.truckCollation,
                AppStateList.trucks,
                'admin'
            ]
        }),
        NgxsDispatchPluginModule.forRoot(),
        NgxsResetPluginModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        AdminSharedModule
    ],
    exports: [
        NgxsModule,
        NgxsStoragePluginModule,
        NgxsDispatchPluginModule,
        NgxsResetPluginModule,
        NgxsReduxDevtoolsPluginModule,
        CommonModule,
        AdminSharedModule
    ],
})
export class StoreModule { }

